import styled from 'styled-components';
import { Button } from '../button/button.component';

export const SkipNavigation = styled(Button)`
  min-width: auto;
  height: auto;
  width: 141px;
  padding: 8px;
  font-size: 12px;
  letter-spacing: -0.55px
  line-height: 12px;
  text-transform: none;
  white-space: nowrap;
  opacity: 0;
  
  &::after {
    display: none !important;
  }
  
  &:focus {
    opacity: 1;
  }
`;
